import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileAlt, faTrash } from "@fortawesome/free-solid-svg-icons";
import config from "../../../config";

const ACCEPTED_TYPES = ["application/pdf", "image/jpeg", "image/png"];
const ACCEPTED_EXTENSIONS = ".pdf, .jpg, .jpeg, .png";

export const FilesForm = ({ setFile, file, setFileInput, onError }) => {

    const selectedFilesChanged = (e) => {
        const selected = e.target.files[0];
        if (!selected) return;
        if (!ACCEPTED_TYPES.includes(selected.type)) {
            onError?.(`Invalid file type. Only ${ACCEPTED_EXTENSIONS} are allowed.`);
            e.target.value = "";
            return;
        }
        if (selected.size > config.MAX_ATTACHMENT_SIZE) {
            onError?.("File is too large. Maximum size is 5 MB.");
            e.target.value = "";
            return;
        }
        setFile(selected);
    };

    const removeFile = () => {
        setFile(null);
        if (setFileInput) setFileInput(null);
    };

    const openFile = () => {
        const url = URL.createObjectURL(file);
        window.open(url, "_blank", "noopener,noreferrer");
    };

    return (
        <div>
            {file && (
                <div className="hp-file-list">
                    <div className="hp-file-item">
                        <div className="hp-file-item__icon">
                            <FontAwesomeIcon icon={faFileAlt} size="sm" />
                        </div>
                        <span
                            className="hp-file-item__name hp-file-item__name--link"
                            onClick={openFile}
                            title="Click to open file"
                        >
                            {file.name}
                        </span>
                        <button
                            type="button"
                            className="hp-file-item__delete"
                            title="Remove file"
                            onClick={removeFile}
                        >
                            <FontAwesomeIcon icon={faTrash} size="xs" />
                        </button>
                    </div>
                </div>
            )}
            <label htmlFor="file-upload-docs" className="hp-file-dropzone">
                <span className="hp-file-dropzone__icon">+</span>
                <span className="hp-file-dropzone__text">Add File</span>
                <span className="hp-file-dropzone__hint">PDF, JPG, JPEG, PNG · max 5 MB</span>
            </label>
            <input
                id="file-upload-docs"
                type="file"
                accept=".pdf,.jpg,.jpeg,.png"
                onChange={selectedFilesChanged}
                ref={(ref) => setFileInput(ref)}
                style={{ display: "none" }}
            />
        </div>
    );
};
